var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{attrs:{"label":_vm.field.label,"prop":_vm.field.prop,"rules":_vm.field.rule}},[_c('el-time-picker',{attrs:{"value-format":"HH:mm:ss","editable":false,"placeholder":'请选择' + _vm.field.label},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }